/* Created 2017-11-15 by Lou Mauget */

import $ from 'jquery';
import { View } from 'backbone';
import template  from 'dashboard/forms/modal/confirmation-modal.ejs';

// (This could be generalizd to a gneeric Yes/Cnacle dialog with text supplied in the model
class ConfirmationModal extends View {

    initialize( opts ){
        super.initialize(opts);

        this.options = opts || {};

        if (!this.model.has('confirmationTitle')) {
            this.model.set('confirmationTitle',  'Confirmation');
        }
        if (!this.model.has('confirmationText')) {
            this.model.set('confirmationText',  'Confirm?');
        }


        if (!this.model.has('height')) {
            this.model.set('height',  220);
        }

        if (!this.model.has('width')) {
            this.model.set('width',  400);
        }

        this.el = '#confirmation-modal';

        $('body').append(this.$el);
    }


    closeModal(){
        $( this.el ).dialog("destroy").remove();
    }

    render() {
        this.closeModal();

        return new Promise( resolve => {
            this.$el.html(template(this.model.toJSON()));
            this.delegateEvents();

            let buttons = [
                {
                    text: 'Yes',
                    'class': 'btn-select-item',
                    click: () => {
                        resolve('Yes');
                        this.closeModal();
                    }
                },
                {
                    'text': 'Cancel',
                    'class': 'btn-select-item',
                    click: () => {
                        resolve('Cancel');
                        this.closeModal();
                    }
                }
            ];

            if(this.model.get("buttons")){
                buttons = this.resolveForButtons(resolve);
            }

            $(this.el).dialog({
                dialogClass: 'no-close',
                autoOpen: true,
                modal: true,
                resizable: false,
                closeOnEscape: false,
                height: this.model.get('height'),
                width: this.model.get('width'),
                buttons: buttons
            });

            $('div[role="dialog"]').draggable({containment: 'body', scroll: false});
        });
    }

    resolveForButtons(resolve){
        let originalButtons = this.model.get('buttons');
            let buttons = originalButtons.map(button => {
                return {
                        text: button.text,
                        'class': 'btn-select-item',
                            click: () => {
                                resolve(button.resolve);
                                this.closeModal();
                            }
                        }
            });
        return buttons;
    }
}

export default ConfirmationModal;
